import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Auth from "@aws-amplify/auth";
import "./AddOrganization.scss";
import "../../styles/global.scss";
import "../../styles/pagelayout.scss";
// @ts-ignore
import Cookies from "js-cookie";
// Components
import Sidebar from "../components/sidebar/Sidebar";
import AddTeamMember from "../components/modalForms/addOrganizationTeam/AddTeamMember";
import TableMUI from "../components/TableMUI/TableMUI";
import PopupTemplate from "../components/PopupTemplate/PopupTemplate";
import OrgInfoForm from "../components/forms/organizationInfoForm";

// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import {
  orgDataDTO,
  orgDataItem,
  orgInfoSubmit,
  orgUserListRows,
} from "../dtos/organization.dtos";
import {
  GetOrg,
  DeleteOrgUser,
  CreateOrganization,
  GetOrgUsers,
  UpdateOrganization,
  CreateOrgUser,
  UpdateOrganizationUser,
} from "../../API/endpoints/Organization";
import { GetAllCountries } from "../../API/endpoints/Common";
import { orgUserTableColumns } from "../components/TableMUI/TableColumns";
import { CreateActivity } from "../../API/endpoints/Dashboard";
import { GetUserProfile } from "../../API/endpoints/User";
import Navbar from "../components/header/NavBar";
import BreadCrumb from "../components/header/BreadCrumb";
import SuccessModal from "../components/Modal/SuccessModal";
import ToastMessage from "../components/toasts/ToastMessage";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { message } from "antd";

function AddOrganization() {
  const params = useParams();
  const [show, setShow] = useState(false);
  const [data, setData] = useState<any>([]);
  const [flag, setFlag] = useState(false);
  const [userID, setUserID] = useState("");
  const [user, setUser] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [defaultTab, setDefaultTab] = useState<any>("organization-info");
  const [showDelete, setShowDelete] = useState(false);
  const [countries, setCountries] = useState(null);
  const [orgID, setOrgID] = useState(params?.orgid ? params.orgid : "");
  const [orgData, setOrgData] = useState<orgDataDTO>({});
  const [uID, setUID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [email, setEmail] = useState<string | undefined>("");
  const [linkSent, setLinkSent] = useState<boolean>(false);
  const [errors, setErrors] = useState("");
  const [roleID, setRoleID] = useState<number>(0);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [basicInfoData, setBasicInfoData] = useState<any>({});
  const [teamMembersData, setTeamMembersData] = useState<any[]>([]); // <-- for team members locally

  const [submitLoading, setSubmitLoading] = useState(false);

  const navigate = useNavigate();

  const handleShow = () => {
    setUserID("");
    setShow(true);
  };
  const handleClose = () => {
    setUserID("");
    setUser({});
    setFlag(false);
    setShow(false);
    setIsEdit(false);
    setFlag(true);
  };
  const handleCloseDeletePopup = () => {
    setFlag(false);
    setShowDelete(false);
    setFlag(true);
  };

  useEffect(() => {
    setUID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (uID) {
      (async () => {
        const response = await GetUserProfile(uID);
        if (response?.data) {
          setUserProfile(response?.data);
          setRoleID(response.data?.user_roles[0]?.roles.id);
        }
      })();
    }
  }, [navigate, uID]);

  useEffect(() => {
    (async () => {
      const roleDetails = await GetRoleById(roleID.toString());
      if (roleDetails?.data?.type === "organization") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "0"
        );
        setPermissions(response?.data);
      } else if (roleDetails?.data?.type === "administrative") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "1"
        );
        setPermissions(response?.data);
      }
    })();
  }, [roleID]);

  useEffect(() => {
    if (
      permissions[0]?.sub_modules[0]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("organization-info");
    } else if (
      permissions[0]?.sub_modules[1]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("team-info");
    }
  }, [permissions]);

  let rows: any[] = [];

  if (data && Array.isArray(data.rows)) {
    rows = data.rows.map((dataItem: orgDataItem) => ({
      id: dataItem.id,
      name:
        dataItem.first_name +
        " " +
        (dataItem.last_name ? dataItem.last_name : ""),
      designation: dataItem.designation,
      role: dataItem.user_roles[0]?.roles?.role_name,
      email: dataItem.email_id,
      phone: dataItem.contact_number,
      code: dataItem.contact_number_code,
      is_active: dataItem.is_active,
      isSaved: true,
    }));
  }

  // Append unsaved users (locally added)
  const unsavedRows = teamMembersData.map((user, index) => ({
    id: `local-${index}`,
    name: `${user.firstName} ${user.lastName || ""}`,
    designation: user.designation,
    role: user.role, // resolve role name from ID if needed
    roleName: user.roleName,
    email: user.email,
    phone: user.phone,
    code: user.code,
    is_active: false,
    isSaved: false, // Flag to distinguish unsaved users
  }));

  rows = [...rows, ...unsavedRows];

  const columns = orgUserTableColumns(
    setUserID,
    setShow,
    setUser,
    setIsEdit,
    setShowDelete,
    setEmail,
    setLinkSent,
    setNotification,
    permissions
  );

  useEffect(() => {
    if (
      permissions[0]?.sub_modules[1]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      orgID &&
        (async () => {
          setData([]);
          const orgUsers = await GetOrgUsers(orgID);
          setData(orgUsers?.data);
        })();
    }
  }, [flag, orgID, permissions]);

  useEffect(() => {
    (async () => {
      const countries = await GetAllCountries(-1);
      setCountries(countries.data);
    })();

    const getOrganizationData = async () => {
      if (params?.orgid) {
        const response = await GetOrg(params.orgid);
        if (response)
          setOrgData({
            company_name: response.data.company_name,
            company_address_line1: response.data.company_address_line1,
            company_address_line2: response.data.company_address_line2
              ? response.data.company_address_line2
              : "",
            company_registration_number:
              response.data.company_registration_number,
            company_address_postal_code: response.data
              .company_address_postal_code
              ? response.data.company_address_postal_code
              : "",
            country_of_origin: response.data.country_of_origin,
            city: response.data.city,
            state: response.data.state,
            website: response.data.website ? response.data.website : "",
            is_active: response.data.is_active,
          });
      }
    };

    getOrganizationData();
  }, [params.orgid, permissions]);

  async function handleDelete(id: string) {
    setFlag(true);
    await DeleteOrgUser(id);
    setFlag(false);
  }

  // const onSubmit = (data: orgInfoSubmit) => {
  //   let org: any = {
  //     company_name: data.organizationName,
  //     company_address_line1: data.address1,
  //     // company_registration_number: data.registrationNumber,
  //     country_of_origin: data.countryOfOrigin,
  //     city: data.city,
  //     state: data.state,
  //   };

  //   if (data.address2) org.company_address_line2 = data.address2;
  //   if (data.pinCode) org.company_address_postal_code = data.pinCode;
  //   if (data.website) org.website = data.website;

  //   // try {
  //   if (!params?.orgid) {
  //     (async () => {
  //       try {
  //         setErrors("");
  //         const res = await CreateOrganization(org);
  //         const activity = await CreateActivity(
  //           `Admin added org: ${data.organizationName}.`
  //         );
  //         console.log(activity);
  //         if (
  //           permissions[0]?.sub_modules[1]?.permissions_actions[1]
  //             ?.permission[0]?.permission === true
  //         ) {
  //           setDefaultTab("team-info");
  //         } else {
  //           navigate("/OrganizationManagement");
  //         }
  //         setOrgID(res.data.id);
  //         setFlag(!flag);
  //       } catch (ex: any) {
  //         if (ex === "Company registration number already exists") {
  //           setErrors(ex);
  //         }
  //       }
  //     })();
  //   } else {
  //     (async () => {
  //       try {
  //         setErrors("");
  //         await UpdateOrganization(orgID, org);
  //         setNotification({
  //           type: "success",
  //           msg: "Updated successfully",
  //         });
  //         const activity = await CreateActivity(
  //           `Org ${data.organizationName} updated.`
  //         );
  //         console.log(activity);
  //       } catch (ex: any) {
  //         if (ex === "Company registration number already exists") {
  //           setErrors(ex);
  //         }
  //       }
  //     })();
  //   }
  //   // } catch (error) {}
  // };

  const onSubmit = (data: orgInfoSubmit) => {
    let org: any = {
      company_name: data.organizationName,
      company_address_line1: data.address1,
      // company_registration_number: data.registrationNumber,
      country_of_origin: data.countryOfOrigin,
      city: data.city,
      state: data.state,
    };

    if (data.address2) org.company_address_line2 = data.address2;
    if (data.pinCode) org.company_address_postal_code = data.pinCode;
    if (data.website) org.website = data.website;

    setBasicInfoData(org);
    if (
      permissions[0]?.sub_modules[1]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("team-info");
    } else {
      navigate("/OrganizationManagement");
    }
  };
  const breadcrumbData =
    [
      {
        name: "BRAND MANAGEMENT",
        url: "/OrganizationManagement",
        active: false,
      },
      {
        name: params?.orgid
          ? orgData.company_name?.toLocaleUpperCase()
          : "ORGANIZATIONS",
        url: "",
        active: false,
      },
      {
        name: params?.orgid ? "EDIT ORGANIZATION" : "ADD NEW ORGANIZATION",
        url: "",
        active: true,
      },
    ] || [];
  const handleNotification = (type: string, msg: string) => {
    setNotification({
      type: type,
      msg: msg,
    });
  };
  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const handleFinalSubmit = async () => {
    const handleExceptionMessage = function (ex: any) {
      console.error("Unhandled API exception:", ex);
    };

    try {

      setSubmitLoading(true);
      let newOrgID = orgID;

      if (!orgID) {
        const res = await CreateOrganization(basicInfoData);
        newOrgID = res.data.id;
        setOrgID(newOrgID);
        await CreateActivity(`Admin added org: ${basicInfoData.company_name}`);
      } else {
        try {
          setErrors("");
          await UpdateOrganization(orgID, basicInfoData);
          setNotification({
            type: "success",
            msg: "Organization updated successfully",
          });
          await CreateActivity(`Org ${basicInfoData.company_name} updated.`);
        } catch (ex: any) {
          if (ex === "Company registration number already exists") {
            setErrors(ex);
            return;
          }
        }
      }

      // ⚡ Merge saved + unsaved team members
      const allTeamMembers = [
        ...(data?.rows || []).map((saved: any) => ({
          id: saved.id,
          firstName: saved.first_name,
          lastName: saved.last_name || "",
          email: saved.email_id,
          code: saved.contact_number_code,
          phone: saved.contact_number,
          designation: saved.designation || "",
          role: saved.user_roles?.[0]?.roles?.id, // assuming you have role id from saved users
          isSaved: true,
        })),
        ...teamMembersData.map((unsaved: any) => ({
          ...unsaved,
          isSaved: false,
        })),
      ];
      console.log(allTeamMembers, "allTeamMembers");

      // ⚡ Create or update users
      for (const member of allTeamMembers) {
        const payload = {
          org_id: newOrgID,
          first_name: member.firstName,
          last_name: member.lastName,
          email_id: member.email,
          contact_number_code: member.code,
          contact_number: member.phone,
          designation: member.designation,
          user_type: "organization",
          role: [member.role],
        };

        try {
          const newPayload = {
            ...payload,
            region: [2],
            department: 1,
          };
          if (member.isSaved && member.id) {
            // Update existing user
            await UpdateOrganizationUser(member.id, newPayload);
            navigate("/OrganizationManagement");
          } else {
            // Create new user
            await CreateOrgUser(payload);
          }
        } catch (ex: any) {
          handleExceptionMessage(ex);
          return;
        }
      }
      setSubmitLoading(false);
      message.success("Organization and team members saved successfully!");
      navigate("/OrganizationManagement");
    } catch (error) {
      setSubmitLoading(false);
      console.error("Final submit failed:", error);
      message.error("Something went wrong while saving. Please try again.");
    }
  };

  return (
    <Container fluid className="pge-layout bg-[#F1F2F7]">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="brand-org" />
        </Col>
        <Col className="content-section p-0">
          <Navbar userProfile={userProfile} />
          <BreadCrumb breadcrumbData={breadcrumbData} />

          <div className="tabs-wraper bg-[#fff] w-[1024px] m-[0_auto] mt-[16px] rounded-[8px] ">
            <div className="flex justify-between ">
              <p className="text-[#1D2939] text-[14px] font-[500] ">
                Add New Organization
              </p>
              {defaultTab === "team-info" && (
                <Button
                  variant="primary"
                  className="btn-primary12 !bg-[#24a0ed] hover:!bg-[#0b5ed7]"
                  onClick={handleFinalSubmit}
                  disabled={submitLoading}
                >
                  Save & Finish
                </Button>
              )}
            </div>
            <Tabs
              // activeKey={params?.orgid ? undefined : defaultTab}
              activeKey={defaultTab}
              onSelect={(k) => {
                if (k === "organization-info" || params?.orgid) {
                  setDefaultTab(k);
                }

              }}
              id="fill-tab-example"
              className="tabs-global"
              fill
            >
              {permissions[0]?.sub_modules[0]?.permissions_actions[1]
                ?.permission[0]?.permission === true && (
                  <Tab
                    eventKey="organization-info"
                    title={
                      <React.Fragment>
                        <div>Basic Info</div>
                      </React.Fragment>
                    }
                  >
                    <OrgInfoForm
                      onSubmit={onSubmit}
                      org={orgData}
                      countries={countries}
                      error={errors}
                      permissions={permissions}
                    />
                  </Tab>
                )}

              {permissions[0]?.sub_modules[1]?.permissions_actions[1]
                ?.permission[0]?.permission === true && (
                  <Tab
                    eventKey="team-info"
                    title={
                      <React.Fragment>
                        <div>Team Info</div>
                      </React.Fragment>
                    }
                  >
                    {permissions[0]?.sub_modules[1]?.permissions_actions[0]
                      ?.permission[0]?.permission === true && (
                        // (!data?.count || orgData.is_active) &&
                        <div className="d-flex justify-content-end mt16px">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleShow}
                            className="btn-primary12 !bg-[#24a0ed] hover:!bg-[#0b5ed7]"
                          >
                            Add Team Member
                          </Button>
                        </div>
                      )}
                    <div className="TableMUIcountainer mt16px">
                      <TableMUI columns={columns} rows={rows} />
                      <AddTeamMember
                        isModalOpen={show}
                        onCancel={handleClose}
                        showDelete={showDelete}
                        setShowDelete={setShowDelete}
                        setFlag={setFlag}
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        orgID={orgID}
                        userID={userID}
                        setDefaultTab={setDefaultTab}
                        user={user}
                        setUser={setUser}
                        setUserID={setUserID}
                        data={data}
                        handleNotification={handleNotification}
                        setTeamMembersData={setTeamMembersData}
                        teamMembersData={teamMembersData}
                        setData={setData}
                      />
                      <PopupTemplate
                        popupHeader="Confirm Deletion."
                        popupBody="Are you sure you want to delete ?"
                        handleFunction={handleDelete}
                        isModalOpen={showDelete}
                        onCancel={handleCloseDeletePopup}
                        id={userID}
                        setFlag={setFlag}
                      />
                      <SuccessModal
                        isModalOpen={linkSent}
                        handleCloseModal={() => {
                          setEmail("");
                          setLinkSent(false);
                        }}
                        email={email}
                        isAdmin={true}
                        btn={true}
                        link=""
                        linkText=""
                        title="Code Sent"
                        bodyText={`A code to reset your password has been sent to
          ${email?.replace(/(\w{1})(.*)(\w{1})@(.*)/, "$1******$3@$4")}`}
                      />
                    </div>
                  </Tab>
                )}
            </Tabs>
          </div>
          <ToastMessage
            notification={notification}
            onCancel={handleCloseNotification}
          />
        </Col>
      </Row>
    </Container >
  );
}

export default AddOrganization;
